<script>
import {mapState, mapActions} from 'vuex';
import SelectLanguage from '../SelectLanguage/SelectLanguage.vue';

export default {
    components: {
        SelectLanguage
    },
    filters: {
        capitalized: (supplierName) => {
            let supplierNameCap = '';
            let words = supplierName.split(' ');
            words.forEach((word) => {
                supplierNameCap += word.substring(0,1).toUpperCase() + word.substring(1, word.length) + ' ';
            });
            return supplierNameCap.substring(0, supplierNameCap.length - 1);
        }
    },
    data () {
        return {
            userDropdownToggled: false
        }
    },
    computed: {
        ...mapState({
            minimized: state => state.nav.minimized,
            user: state => state.auth.user,
            supplier: state => state.auth.supplier,
            open: state => state.nav.menu.open
        })
    },
    methods: {
        ...mapActions({
            unauthenticate: 'auth/unauthenticate',
            toggleMinimizeNav: 'nav/toggleMinimizeNav',
            toggleNavMenu: 'nav/toggleNavMenu'
        }),
        admin() {
            this.$router.push('dashboard/admin');
        },
        signOut() {
            this.unauthenticate({
                level: 'info',
                text: 'signIn.logoutNotice'
            })
        }
    }
}
</script>

<template>
    <div :class="{'top-menu--minimized': minimized}" class="top-menu">
        <div class="top-menu__left">
            <div class="top-menu__brand">
                <img src="https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/logo-greybackground.svg" class="top-menu__logo">
                <img src="https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/icon-greybackground.png" class="top-menu__icon">
            </div>
            <div class="top-menu__nav-toggle" @click="toggleMinimizeNav">
                <i class="fa fa-fw fa-bars"/>
            </div>
            <div v-if="!user.contractManager" class="top-menu__welcome-note">
                {{ $t('topMenu.left.welcome') }} {{ supplier.name | capitalized }}
            </div>
        </div>
        <div class="top-menu__right">
            <div class="top-menu__user-controls" @click="toggleNavMenu()">
                <i class="fa fa-fw fa-user"/>
                {{ user.firstName }} {{ user.lastName }}
            </div>
            <transition name="slide-top">
                <ul v-if="open" class="top-menu__user-dropdown">
                    <li class="top-menu__user-dropdown-item">
                        <router-link v-if="user.admin" tag="a" to="/dashboard/admin" class="top-menu__user-dropdown-link">
                            <i class="fa fa-key"/>
                            {{ $t('topMenu.right.admin') }}
                        </router-link>
                        <router-link v-if="!user.contractManager" tag="a" to="/dashboard/account" class="top-menu__user-dropdown-link">
                            <i class="fa fa-user"/>
                            {{ $t('topMenu.right.account') }}
                        </router-link>
                        <a class="top-menu__user-dropdown-link" @click="signOut">
                            <i class="fa fa-sign-out-alt"/>
                            {{ $t('topMenu.right.logout') }}
                        </a>
                    </li>
                </ul>
            </transition>
            <div class="top-menu__select-language">
                <select-language/>
            </div>

        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/TopMenu/TopMenu.vue